import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Pilihan1 from '../../../assets/images/game/w2_assets/THE-SIMPSONS-1.png';
import AssetMeteor from '../../../assets/images/game/w2_assets/asset-meteor.png';
import AssetBintang from '../../../assets/images/game/w2_assets/asset-bintang.png';

const Soal7 = () => {
    return (
        <>
            <Container className="position-relative front">
                <Row>
                    <Col md="12" className="text-center game-px">
                        <Row>
                            <Col>
                                <p className="super-title-soal7 montserrat text-light">
                                    Hoaks juga disebarkan dalam bentuk foto dan video. Pada  <br />
                                    bagian ini kamu diminta melakukan penelusuran cek fakta <br />
                                    terkait sebuah klaim video hoaks.
                                </p>
                            </Col>
                        </Row>
                        <Row className="pt-4">
                            <Col md="12">
                                <Card className="card-game front">
                                    <CardBody>
                                        <Row>
                                            <Col className="">
                                                <div className="pb-">
                                                    <img src={Pilihan1} alt="Klaim Hoaks" className="w-100" />
                                                </div>
                                                <span className="judul-pilihan-soal-2">PENJELASAN KLAIM HOAKS</span>
                                                <div className="pt-4">
                                                    <p className="desc-soal6 montserrat text-start">
                                                        Beredar di media sosial, bahwa Kartun The Simpsons telah memprediksi  peluncuran<br />vaksin pada tahun 2021 hingga 2023.  <br />
                                                        <br />
                                                        Narasi Terjemahan Klaim: <br />
                                                        <br />
                                                        “...Vaksin akan melakukan perannya dalam dua tahun...”
                                                        <br />
                                                        Wow, kue keberuntungan di sini benar-benar lebih akurat.
                                                        <br />
                                                        <br />
                                                        2 0  2  1
                                                        <br />
                                                        2 0  1  1
                                                        <br />
                                                        2 0 2 3
                                                        <br />
                                                        6    6 6
                                                        <br />
                                                        Vaksin akan melakukan perannya dalam dua tahun.”
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <img src={AssetBintang} alt="" className="asset-bintang img-asset" />
                                <img src={AssetMeteor} alt="" className="asset-meteor img-asset" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Soal7